import { render, staticRenderFns } from "./DataSetMetadataSchemaDetailForm.vue?vue&type=template&id=89000ef8&scoped=true"
import script from "./DataSetMetadataSchemaDetailForm.vue?vue&type=script&lang=js"
export * from "./DataSetMetadataSchemaDetailForm.vue?vue&type=script&lang=js"
import style0 from "./DataSetMetadataSchemaDetailForm.vue?vue&type=style&index=0&id=89000ef8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89000ef8",
  null
  
)

export default component.exports